export const withTimeout = (promise, ms) => new Promise(async (resolve, reject) => {
  const timer = setTimeout(() => reject(new Error('Timeout')), ms);
  try {
    const result = await promise;
    clearTimeout(timer);
    resolve(result);
  } catch (err) {
    clearTimeout(timer);
    reject(err);
  }
});
//# sourceMappingURL=with-timeout.js.map